exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:300,700&display=swap);", ""]);

// module
exports.push([module.id, ":root{--section-color-yellow:#f9a826;--section-color-blue:#536dfe;--section-color-red:#f50057;--section-color-green:#00bfa6}h1,h2,h3{font-family:Montserrat,sans-serif;margin:10px 0}p{font-family:Lato,sans-serif}*{margin:0;padding:0;box-sizing:border-box}@media screen and (max-width:900px){body{font-size:14px;min-width:350px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58ed10eb","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 121
// module chunks = 0